export default __webpack_public_path__ + "d1f0387dae70779c66e257e1f6f572d4.png";